// extracted by mini-css-extract-plugin
module.exports = {"modal":"CreateStrategyModal_modal__1wOKb","loader":"CreateStrategyModal_loader__3E21B","container":"CreateStrategyModal_container__23jOE","body":"CreateStrategyModal_body__MCSut"};